// extracted by mini-css-extract-plugin
export var productQuantity = "ProductQuantity_productQuantity__51iQG";